import { render } from "./OperatorApplicationSuggestedTemplatesWrapper.vue?vue&type=template&id=1b6d2774&scoped=true&ts=true"
import script from "./OperatorApplicationSuggestedTemplatesWrapper.vue?vue&type=script&lang=ts"
export * from "./OperatorApplicationSuggestedTemplatesWrapper.vue?vue&type=script&lang=ts"

import "./OperatorApplicationSuggestedTemplatesWrapper.vue?vue&type=style&index=0&id=1b6d2774&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6d2774"]])

export default __exports__